export default {
  $listener: null,
  listen: function($callback) {
    if (typeof $callback === "function")
      this.$listener = $callback;
  },
  show: function(percent) {
    if (this.$listener != null && typeof this.$listener === "function")
      this.$listener("show", percent)
  },
  hide: function() {
      this.$listener("hide");
  }
}



// WEBPACK FOOTER //
// ./src/assets/upload-listener.js